export default __webpack_public_path__ + "17e57d6331ca7ca9f9af30290b959a40.png";